import { Injectable } from '@angular/core';

import iconsSvgs from '../models/icons-svgs';

export type IconType = keyof typeof iconsSvgs;

@Injectable()
export class IconService {
  
  public getSvgForName(name) {
    return iconsSvgs[name];
  }
}